// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-account-wrapper {
    width: 100%;
    min-height: calc(100vh - 70px);
    background-color: var(--bg-app);
    padding: 0 20px 40px 20px;
}

.account-hero {
    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);
    color: white;
    padding: 60px 20px 80px 20px;
    margin: 0 -20px 40px -20px;
    position: relative;
    overflow: hidden;
    text-align: center;
}

.account-hero::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -10%;
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.03);
    border-radius: 50%;
}

.account-hero-content {
    position: relative;
    z-index: 2;
    max-width: 800px;
    margin: 0 auto;
}

.hero-badge {
    display: inline-block;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(4px);
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: var(--brand-accent);
    font-weight: 700;
}

.hero-title {
    font-size: 2.5rem;
    font-weight: 800;
    margin: 0 0 10px 0;
}

.hero-subtitle {
    font-size: 1.1rem;
    opacity: 0.8;
    margin: 0;
    line-height: 1.5;
}

.account-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    max-width: 1100px;
    margin: -60px auto 0 auto;
    position: relative;
    z-index: 10;
}

@media (max-width: 900px) {
    .account-grid {
        grid-template-columns: 1fr;
        margin-top: -40px;
    }
}

.account-card {
    background-color: var(--bg-card);
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    padding: 30px;
    border: 1px solid var(--border-light);
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    border-bottom: 1px solid var(--bg-app);
    padding-bottom: 20px;
    margin-bottom: 20px;
}

.card-title h2 {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--brand-primary);
    margin: 0 0 4px 0;
}

.card-title p {
    font-size: 0.9rem;
    color: var(--text-muted);
    margin: 0;
}

.btn-icon {
    background: transparent;
    border: 1px solid var(--border-light);
    color: var(--text-muted);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
}

.btn-icon:hover {
    background-color: var(--bg-app);
    color: var(--brand-primary);
    border-color: var(--brand-primary);
}

.profile-main {
    display: flex;
    align-items: center;
    gap: 20px;
}

.avatar-large {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: var(--brand-accent);
    color: var(--brand-primary);
    font-size: 2rem;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 4px solid white;
    box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.profile-identity h3 {
    margin: 0 0 4px 0;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--text-main);
}

.profile-identity span {
    color: var(--text-muted);
    font-size: 0.95rem;
}

.info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
}

.info-item {
    background-color: var(--bg-app);
    padding: 12px 16px;
    border-radius: var(--radius-md);
}

.info-label {
    font-size: 0.75rem;
    text-transform: uppercase;
    color: var(--text-muted);
    font-weight: 700;
    display: block;
    margin-bottom: 4px;
}

.info-value {
    font-size: 1rem;
    color: var(--text-main);
    font-weight: 500;
    word-break: break-all;
}

.stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
    gap: 16px;
}

.stat-box {
    background-color: var(--bg-app);
    border-radius: var(--radius-md);
    padding: 20px;
    text-align: center;
    transition: transform 0.2s;
    border: 1px solid transparent;
}

.stat-box:hover {
    transform: translateY(-2px);
    background-color: white;
    border-color: var(--brand-accent);
    box-shadow: var(--shadow-sm);
}

.stat-number {
    font-size: 2rem;
    font-weight: 800;
    color: white;
    display: block;
    line-height: 1.2;
}

.stat-name {
    font-size: 0.85rem;
    color: var(--text-muted);
    text-transform: uppercase;
    font-weight: 600;
}

.loading-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 60vh;
    color: var(--text-muted);
}
.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0,0,0,0.1);
    border-top-color: var(--brand-accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}
@keyframes spin { to { transform: rotate(360deg); } }

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 16px;
    border-radius: var(--radius-md);
    text-align: center;
    max-width: 600px;
    margin: 40px auto;
}
/* ── Últimos partidos ── */
.recent-matches-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.recent-match-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 14px;
    border-radius: 10px;
    background: var(--bg-app, #f8fafc);
    border-left: 3px solid transparent;
}

.recent-match--win  { border-left-color: var(--brand-accent); }
.recent-match--loss { border-left-color: #f43f5e; }

.recent-match-badge {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 800;
    flex-shrink: 0;
}

.badge--win  { background: var(--brand-accent); color: var(--brand-primary, #0f172a); }
.badge--loss { background: #f43f5e; color: white; }

.recent-match-opponent {
    flex: 1;
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--text-primary, #0f172a);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.recent-match-date {
    font-size: 0.78rem;
    color: var(--text-secondary, #64748b);
    white-space: nowrap;
    flex-shrink: 0;
}

.no-matches-msg {
    color: var(--text-secondary, #64748b);
    font-size: 0.88rem;
    text-align: center;
    padding: 20px 0;
}

/* ── Responsive ── */
@media (max-width: 600px) {
    .account-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/MyAccount.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,yBAAyB;AAC7B;;AAEA;IACI,0EAA0E;IAC1E,YAAY;IACZ,4BAA4B;IAC5B,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,0BAA0B;IAC1B,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;IAC1C,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;AACJ;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,sCAAsC;IACtC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,2BAA2B;IAC3B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,qCAAqC;IACrC,wBAAwB;IACxB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,kBAAkB;IAClB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,qCAAqC;IACrC,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;AACvB;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,kCAAkC;IAClC,kCAAkC;AACtC;;AAEA,sBAAsB,sCAAsC,EAAE;AAC9D,sBAAsB,0BAA0B,EAAE;;AAElD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA,eAAe,+BAA+B,EAAE,oCAAoC,EAAE;AACtF,eAAe,mBAAmB,EAAE,YAAY,EAAE;;AAElD;IACI,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".my-account-wrapper {\n    width: 100%;\n    min-height: calc(100vh - 70px);\n    background-color: var(--bg-app);\n    padding: 0 20px 40px 20px;\n}\n\n.account-hero {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, #1e293b 100%);\n    color: white;\n    padding: 60px 20px 80px 20px;\n    margin: 0 -20px 40px -20px;\n    position: relative;\n    overflow: hidden;\n    text-align: center;\n}\n\n.account-hero::before {\n    content: '';\n    position: absolute;\n    top: -50%;\n    right: -10%;\n    width: 400px;\n    height: 400px;\n    background: rgba(255, 255, 255, 0.03);\n    border-radius: 50%;\n}\n\n.account-hero-content {\n    position: relative;\n    z-index: 2;\n    max-width: 800px;\n    margin: 0 auto;\n}\n\n.hero-badge {\n    display: inline-block;\n    background: rgba(255, 255, 255, 0.1);\n    backdrop-filter: blur(4px);\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 0.85rem;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n    margin-bottom: 16px;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    color: var(--brand-accent);\n    font-weight: 700;\n}\n\n.hero-title {\n    font-size: 2.5rem;\n    font-weight: 800;\n    margin: 0 0 10px 0;\n}\n\n.hero-subtitle {\n    font-size: 1.1rem;\n    opacity: 0.8;\n    margin: 0;\n    line-height: 1.5;\n}\n\n.account-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 30px;\n    max-width: 1100px;\n    margin: -60px auto 0 auto;\n    position: relative;\n    z-index: 10;\n}\n\n@media (max-width: 900px) {\n    .account-grid {\n        grid-template-columns: 1fr;\n        margin-top: -40px;\n    }\n}\n\n.account-card {\n    background-color: var(--bg-card);\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    padding: 30px;\n    border: 1px solid var(--border-light);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    border-bottom: 1px solid var(--bg-app);\n    padding-bottom: 20px;\n    margin-bottom: 20px;\n}\n\n.card-title h2 {\n    font-size: 1.25rem;\n    font-weight: 700;\n    color: var(--brand-primary);\n    margin: 0 0 4px 0;\n}\n\n.card-title p {\n    font-size: 0.9rem;\n    color: var(--text-muted);\n    margin: 0;\n}\n\n.btn-icon {\n    background: transparent;\n    border: 1px solid var(--border-light);\n    color: var(--text-muted);\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.2s;\n}\n\n.btn-icon:hover {\n    background-color: var(--bg-app);\n    color: var(--brand-primary);\n    border-color: var(--brand-primary);\n}\n\n.profile-main {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.avatar-large {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background-color: var(--brand-accent);\n    color: var(--brand-primary);\n    font-size: 2rem;\n    font-weight: 800;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 4px solid white;\n    box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n}\n\n.profile-identity h3 {\n    margin: 0 0 4px 0;\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: var(--text-main);\n}\n\n.profile-identity span {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 16px;\n}\n\n.info-item {\n    background-color: var(--bg-app);\n    padding: 12px 16px;\n    border-radius: var(--radius-md);\n}\n\n.info-label {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    color: var(--text-muted);\n    font-weight: 700;\n    display: block;\n    margin-bottom: 4px;\n}\n\n.info-value {\n    font-size: 1rem;\n    color: var(--text-main);\n    font-weight: 500;\n    word-break: break-all;\n}\n\n.stats-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n    gap: 16px;\n}\n\n.stat-box {\n    background-color: var(--bg-app);\n    border-radius: var(--radius-md);\n    padding: 20px;\n    text-align: center;\n    transition: transform 0.2s;\n    border: 1px solid transparent;\n}\n\n.stat-box:hover {\n    transform: translateY(-2px);\n    background-color: white;\n    border-color: var(--brand-accent);\n    box-shadow: var(--shadow-sm);\n}\n\n.stat-number {\n    font-size: 2rem;\n    font-weight: 800;\n    color: white;\n    display: block;\n    line-height: 1.2;\n}\n\n.stat-name {\n    font-size: 0.85rem;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    font-weight: 600;\n}\n\n.loading-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 60vh;\n    color: var(--text-muted);\n}\n.spinner {\n    width: 40px;\n    height: 40px;\n    border: 4px solid rgba(0,0,0,0.1);\n    border-top-color: var(--brand-accent);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    margin-bottom: 16px;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 16px;\n    border-radius: var(--radius-md);\n    text-align: center;\n    max-width: 600px;\n    margin: 40px auto;\n}\n/* ── Últimos partidos ── */\n.recent-matches-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.recent-match-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 14px;\n    border-radius: 10px;\n    background: var(--bg-app, #f8fafc);\n    border-left: 3px solid transparent;\n}\n\n.recent-match--win  { border-left-color: var(--brand-accent); }\n.recent-match--loss { border-left-color: #f43f5e; }\n\n.recent-match-badge {\n    width: 26px;\n    height: 26px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem;\n    font-weight: 800;\n    flex-shrink: 0;\n}\n\n.badge--win  { background: var(--brand-accent); color: var(--brand-primary, #0f172a); }\n.badge--loss { background: #f43f5e; color: white; }\n\n.recent-match-opponent {\n    flex: 1;\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: var(--text-primary, #0f172a);\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.recent-match-date {\n    font-size: 0.78rem;\n    color: var(--text-secondary, #64748b);\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.no-matches-msg {\n    color: var(--text-secondary, #64748b);\n    font-size: 0.88rem;\n    text-align: center;\n    padding: 20px 0;\n}\n\n/* ── Responsive ── */\n@media (max-width: 600px) {\n    .account-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
